module.exports = __webpack_public_path__ + "images/emoji/m.983e416e3322d497e032.png";